import { type FunctionComponent } from "react";
import { Button, Input, Space } from "antd";

// Shared emoji picker used by the habit and badge forms: a clickable grid of suggested emojis
// plus a free-text field so a trainer can still paste any emoji not in the grid. Works as an
// antd Form.Item control (value / onChange).

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  /** Suggested emojis rendered as the quick-pick grid. */
  options: readonly string[];
  /** Grid columns (default 8). */
  columns?: number;
};

export const EmojiPicker: FunctionComponent<Props> = ({ value, onChange, options, columns = 8 }) => {
  const isCustom = Boolean(value) && !options.includes(value as string);

  return (
    <Space direction="vertical" size={8} style={{ width: "100%" }}>
      <div style={{ display: "grid", gap: 6, gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {options.map((emoji) => (
          <Button
            key={emoji}
            type={value === emoji ? "primary" : "default"}
            onClick={() => onChange?.(emoji)}
            style={{ fontSize: 18, height: 38, padding: 0 }}
            aria-label={`Ikona ${emoji}`}
          >
            {emoji}
          </Button>
        ))}
      </div>
      <Input
        value={isCustom ? value : ""}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder="…lub wklej własne emoji"
        // No maxLength: it counts UTF-16 units, which would truncate multi-codepoint emoji
        // (ZWJ family, skin tone, flags). The stored value is a single emoji by convention.
        style={{ width: 200 }}
      />
    </Space>
  );
};

export default EmojiPicker;
